// 修改API接口 进行统一

import axios from 'axios';
import baseUrl from './common';


/**
 * eidtAppID - 新增appID
 * @param  {any} params - _id & app_name & bundle & package & sign
 */
export const addAppID = (params:any) => axios({
    url: `${baseUrl}/api/gateway/add`,
    method: 'post',
    data: params,
});

/**
 *  获取当前产品的所有 APPID
 */
export const getAppList = params => axios({
    url: `${baseUrl}/api/gateway/get`,
    method: 'get',
    params,
});

/**
 * eidtAppID - 编辑appID
 * @param  {any} params - _id & app_name & bundle & package & sign
 */
export const editAppID = (params:any) => axios({
    url: `${baseUrl}/api/gateway/modify`,
    method: 'post',
    data: params,
});

/**
 * deleteAppID - 删除app
 * @param  {any} params  - _id product
 */
export const deleteApp = (params:any) => axios({
    url: `${baseUrl}/api/gateway/delete`,
    method: 'post',
    data: params,

});

/**
 * getCurrentAppReport - 获取当前ID的计费统计
 * @param  {any} params - _id & start & end product
 */
export const getCurrentChargeAppReport = (params:any) => axios({
    url: `${baseUrl}/api/gateway/charge_statistics`,
    method: 'get',
    params,
});

/**
 * getCurrentAppReport - 获取当前ID的运营商统计
 * @param  {any} params - _id & start & end product
 */
export const getCurrentoperatorAppReport = (params:any) => axios({
    url: `${baseUrl}/api/gateway/operator_statistics`,
    method: 'get',
    params,
});

/**
 * 获取应用列表
 */
export const getCurrentApplist = (params:any) => axios({
    url: `${baseUrl}/api/gateway/app_list`,
    method: 'get',
    params,
});
